import React, { PropTypes } from 'react';
import Form, { FormActions, FormBody, SelectInput, SwitchInput, TextInput } from "./Form";
import { inject, observer } from 'mobx-react';
import { observable, autorun, action, toJS } from 'mobx';
import moment from 'moment';
import { token, preference } from '../libs/localStorage';

@inject('userPreferenceStore')
@observer
export default class Preferences extends React.Component {

  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  dispose;
  @observable preference = {
    id: token.getDecoded().id,
    timezone: 'UTC',
    station_redirect: 'meta-data',
    common_station_search: 0,
    status_time: '',
  };

  componentWillMount() {
    const { userPreferenceStore } = this.props;
    userPreferenceStore.fetchItems();
    this.dispose = autorun(() => {
      if (userPreferenceStore.items.length > 0) {
        this.reset(userPreferenceStore.items[0])
      }
    })
  }

  @action reset(preference) {
    this.preference = preference.asJson || {
      // timezone: JSON.parse(window.localStorage.preference || '{}').timezone || moment.tz.guess()
      // timezone: preference.get().timezone || moment.tz.guess()
      timezone: preference.get().timezone || 'UTC',
      station_redirect: preference.get().station_redirect || 'meta-data',
      common_station_search: preference.get().common_station_search || '0',
      status_time: preference.get().status_time || 'timestamp',
    };
  }

  @action onChangeTimeZone = e => {
    this.preference.timezone = e.target.value;
  };

  onSaveSettings = e => {
    e.preventDefault();
    const { userPreferenceStore } = this.props;
    const { notify } = this.context;

    // window.localStorage.preference = JSON.stringify({
    //   ...JSON.parse(window.localStorage.preference || '{}'),
    //   timezone: this.preference.timezone
    // });

    preference.set({
      timezone: this.preference.timezone,
      station_redirect: this.preference.station_redirect,
      common_station_search: this.preference.common_station_search,
      status_time: this.preference.status_time,
    });

    // let payload = {
    //   id: token.getDecoded().id,
    //   ...this.preference
    // };

    userPreferenceStore.updateItem(this.preference).then(() => {
      notify.success({ message: 'Setting saved.' })
    }).catch(notify.error)
  };

  render() {
    // const {userPreferenceStore} = this.props;
    let allTimezones = moment.tz.names().map(item => ({ value: item, label: `${item} (${moment.tz(item).zoneAbbr()})` }));

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput
              label='Timezone'
              value={this.preference.timezone} options={allTimezones} onChange={this.onChangeTimeZone}
              fields={{ label: 'label', value: 'value' }}
              displayLabel={<div>Timezone<i className='fa fa-question-circle' style={{ fontSize: '15px' }} data-toggle="tooltip" title="Time/Timestamp will be displayed in selected timezone in observation, monitoring, analysis and csv downloads." /></div>}
            />
            <SelectInput
              label={'Station Redirect'}
              value={this.preference.station_redirect}
              fields={{ label: 'name', value: 'value' }}
              options={[
                { name: 'Meta Data', value: 'meta-data' },
                { name: 'Observation', value: 'observation' },
                { name: 'Full Observation', value: 'full-observation' },
                { name: 'QC Check', value: 'qc-check' },
                { name: 'Edit Observation', value: 'edit-observation' },
                { name: 'Monitoring', value: 'monitoring' },
                { name: 'Maintenance', value: 'maintenance' },
                { name: 'Location', value: 'location' },
              ]}
              onChange={e => this.preference.station_redirect = e.target.value}
            />
            <SwitchInput label='Common Station Search' value={!!this.preference.common_station_search} onChange={() => this.preference.common_station_search = ~this.preference.common_station_search + 2} />
            <SelectInput 
              label={'Status Time'}
              value={this.preference.status_time}
              fields={{ label: 'name', value: 'value' }}
              options={[
                { name: 'Server Time', value: 'timestamp' },
                { name: 'Device Time', value: 'time' },
              ]}
              onChange={e => this.preference.status_time = e.target.value}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.onSaveSettings}>Save</button>
          </FormActions>
        </Form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Preferences.js